// extracted by mini-css-extract-plugin
module.exports = {"container":"GeneralInfoForm_container__3-GV3","row":"GeneralInfoForm_row__R3UFu","input":"GeneralInfoForm_input__mfiHq","submit__btn":"GeneralInfoForm_submit__btn__3s3uu"};